import script from "./ProfileCareerDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCareerDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCareerDrawer.vue?vue&type=style&index=0&id=5d93d752&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d93d752"]])

export default __exports__